import { isNotUndefined } from 'infrastructure/functions';

import {
  genThresholdText,
  additionalFollowUpText,
  croOrDncText,
  needEscalateText,
  uniqueDaysTextWithType,
  readingInTargetRangeText,
} from '../helpers';

import type { TMaSpO2GreenDataOptional } from '../../types';

export const spo2 = (data: TMaSpO2GreenDataOptional) => {
  let text = '';

  const thresholdTextSpo2 = genThresholdText(
    'SpO2',
    data.spo2Avg,
    data.spo2Avg30days,
    data.spo2Avg90days,
  );
  if (thresholdTextSpo2.trim()) text += `\n${thresholdTextSpo2}`;

  const thresholdTextPuls = genThresholdText(
    'pulse',
    data.pulseAvg,
    data.pulseAvg30days,
    data.pulseAvg90days,
  );
  if (thresholdTextPuls.trim()) text += `\n${thresholdTextPuls}`;

  const inTargetRangeText = readingInTargetRangeText(
    data.spo2AndPulseWithinRange,
    data.spo2AndPulseWithinRangeComment,
  );
  if (inTargetRangeText.trim()) text += `\n${inTargetRangeText}`;

  if (isNotUndefined(data.uniqueDays)) {
    text += '\n';
    text += uniqueDaysTextWithType('SpO2', data.uniqueDays);
  }

  if (croOrDncText(data).trim()) text += `\n${croOrDncText(data)}`;

  if (additionalFollowUpText(data).trim())
    text += `\n${additionalFollowUpText(data)}`;

  if (needEscalateText(data).trim()) text += `\n${needEscalateText(data)}`;

  if (data.freeTextComments?.trim()) text += `\n${data.freeTextComments}. `;

  return text;
};
